import React, {useState} from 'react'
import {CSVLink} from 'react-csv'

type Props = {
  reload: any

  csvDownloadFun: () => void
  csvRef: any
  csvHeaders: any
  downloadData: any
  downloadFileName: string
}

const DownloadCsv = ({
  csvDownloadFun,
  reload,

  csvHeaders,
  csvRef,

  downloadData,
  downloadFileName,
}: Props) => {
  const [csv, setCsv] = useState<boolean>(false)
  return (
    <>
      <button
        className='btn btn-active-primary btn-active-icon-white btn-light-primary  fw-bold fs-base'
        onClick={() => {
          csvDownloadFun()
        }}
      >
        <span className='svg-icon svg-icon-2'>
          {' '}
          <svg
            width='14'
            height='15'
            viewBox='0 0 18 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M1.5 5C1.5 3.75736 2.50736 2.75 3.75 2.75H9.75C10.1642 2.75 10.5 3.08579 10.5 3.5C10.5 3.91421 10.1642 4.25 9.75 4.25H3.75C3.33579 4.25 3 4.58579 3 5V14.375C3 14.7892 3.33579 15.125 3.75 15.125H12.75C13.1642 15.125 13.5 14.7892 13.5 14.375V11.375C13.5 10.9608 13.8358 10.625 14.25 10.625C14.6642 10.625 15 10.9608 15 11.375V14.375C15 15.6177 13.9927 16.625 12.75 16.625H3.75C2.50736 16.625 1.5 15.6177 1.5 14.375V5Z'
              fill='currentColor'
            />
            <path
              opacity='0.5'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M12.0324 2.78217C12.3253 2.48928 12.8002 2.48928 13.0931 2.78217L16.0931 5.78217C16.3738 6.06297 16.3871 6.51397 16.1233 6.81077L13.1233 10.1858C12.8481 10.4953 12.374 10.5232 12.0644 10.248C11.7548 9.97287 11.7269 9.4988 12.0022 9.1892L13.961 6.98545C11.8311 6.94434 10.4591 7.22259 9.45353 7.85818C8.23463 8.62857 7.39921 10.023 6.52142 12.5579C6.38588 12.9493 5.95871 13.1568 5.5673 13.0212C5.17588 12.8856 4.96846 12.4585 5.10399 12.0671C5.99923 9.48177 6.97241 7.6519 8.65208 6.59023C9.94658 5.77204 11.567 5.47002 13.6709 5.48129L12.0324 3.84283C11.7394 3.54993 11.7394 3.07506 12.0324 2.78217Z'
              fill='currentColor'
            />
          </svg>
        </span>

        <span className='csvTemplate'>
          Exports
          {reload ? <div className='spinner-border spinner-border-sm ms-1'></div> : null}
        </span>
      </button>

      <CSVLink
        headers={csvHeaders}
        data={downloadData}
        asyncOnClick={true}
        filename={downloadFileName}
        className='btn btn-light-primary fw-bold fs-base d-none'
        onClick={() => setCsv(true)}
        ref={csvRef}
      >
        <span className='csvTemplate'>
          Download
          {reload && csv ? (
            <div className='spinner-border text-primary spinner-border-sm'></div>
          ) : null}
        </span>
      </CSVLink>
    </>
  )
}

export default DownloadCsv
